// list of allowed booking_status options ("requested" is also valid, but we will not have that status on Guest Platform)
const allowedStatuses = ["processing", "booked", "error", "cancelled"];

export const isAllowedBookingStatus = (bookingStatus: string): boolean => {
  return allowedStatuses.indexOf(bookingStatus) > -1;
};
